import CreateTournamentForm from "../../components/CreateTournamentForm/CreateTournamentForm";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import { Link } from "react-router-dom";
import SEOHead from "../../components/SEO/SEOHead";

export default function CreateTournament() {
  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "Create Tournament" },
  ];

  return (
    <div className="flex flex-col bg-brand-cream min-h-screen">
      <SEOHead
        title="Create a tournament - Bowling Tournament App"
        description="Create a bowling tournament."
        canonicalUrl="/create-tournament"
        noIndex
      />
      <div className="max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-12">
        <div className="flex justify-center mb-3 sm:mb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <CreateTournamentForm />
        <p className="mt-6 text-center text-sm text-brand-muted">
          <Link
            to="/tournaments"
            className="text-brand-charcoal hover:underline"
          >
            Back to Tournaments
          </Link>
        </p>
      </div>
    </div>
  );
}
